import { render } from "./GrowthStatisticsTable.vue?vue&type=template&id=97d88bb0&scoped=true"
import script from "./GrowthStatisticsTable.vue?vue&type=script&lang=js"
export * from "./GrowthStatisticsTable.vue?vue&type=script&lang=js"

import "./GrowthStatisticsTable.vue?vue&type=style&index=0&id=97d88bb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d88bb0"]])

export default __exports__